export const errorMapping = {
  "smart-token-expired":
    "Sorry, your current session has expired. Please launch the application again",
  "default-msg":
    "An unexpected error has occurred. Please launch the application again"
};
export default errorMapping;
